
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.y-border {
  display:block;
  padding-top:1rem;
  padding-bottom:1rem;
  border-top:1px solid var(--neutral-gray-4);
  border-bottom:1px solid var(--neutral-gray-4)
}
.author-card {
  font-family:var(--ff-display)
}
.author-card-heading {
  margin-bottom:1rem;
  font-weight:var(--fw-semibold);
  color:var(--primary-blue)
}
.author-card-image {
  margin-bottom:1rem;
  overflow:hidden;
  border-radius:0.75rem
}
.author-card-title {
  margin-bottom:0px;
  font-weight:var(--fw-bold);
  color:var(--primary-blue-light-2)
}
.author-card-topic {
  margin:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-semibold);
  color:var(--neutral-gray-1)
}
.author-card-cta {
  margin-top:1rem
}
`;